export const ADMIN_SECTION_ITEM_PAGE_URL = (itemId: number) =>
  `/admin/item_moderation_actions/${itemId}`
